<template>
  <div clas="container">

    <!-- Show the loader while the app is initializing -->
    <LoadingVue v-if="isLoading == true || dashboardStore.coinSupported.length == 0 || !auth" />

    <!-- Your main app content goes here -->
    <div>
      <router-view v-if="dashboardStore.loading == false && auth && balance" />


    </div>
    <div>
      <MenuBar v-if="dashboardStore.showIframe == false" />
    </div>


  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useDashboardStore } from './store/dashboardStore'; // Store for managing global state
import LoadingVue from './components/LoadingVue.vue'; // Your loading component
import { auth, coinSupported, data } from './main';
import { balance } from './main';
import MenuBar from './components/MenuBar.vue';


// Access the store to track loading state
const dashboardStore = useDashboardStore();

// Compute the loading state
const isLoading = computed(() => dashboardStore.loading);

const coinSupported_ = computed(() => {
  return coinSupported
})
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.container {
  position: relative;
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-top);
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }

    
  }
}
</style>
